import { Table } from '@src/components';
import { RenderColumns } from './columns';
import { useTranslation } from 'react-i18next';
import { SortDirection } from '@src/types/common';
import { useState } from 'react';
import { useGetPayoutsQuery } from '@src/services/affiliate/affiliateApiSlice';

export function PayoutsList() {
  const { t } = useTranslation();
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<SortDirection | null>(null);

  const { data, isLoading, isFetching } = useGetPayoutsQuery({});

  const handleSortChange = (columnKey: string, order: SortDirection | null) => {
    if (order === null) {
      setSortBy(null);
      setSortOrder(null);
    } else {
      setSortBy(columnKey);
      setSortOrder(order);
    }
  };

  const columns = RenderColumns({
    t,
    sorterState: { sortBy, sortOrder, onSortChange: handleSortChange },
  });

  if (data?.total === 0) {
    return <></>;
  }

  return (
    <Table
      title={t('pages.affiliate.payouts.title')}
      headerClassName='bg-wl-background rounded-2xl p-6'
      searchPlaceholder={t('general.search')}
      scroll={{ x: 1 }}
      loading={isLoading || isFetching}
      columns={columns}
      dataSource={data?.items ?? []}
    />
  );
}
